import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Fade-up scroll reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked line reveal — animates upward from behind an overflow-hidden wrapper
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="text-mask-line">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.05, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

// Same as MaskLine but triggered on scroll into view
export const MaskLineInView = ({ children, delay = 0, className = "" }) => (
  <span className="text-mask-line">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1, ease: EASE, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export { EASE };
